import { useFormContext } from 'react-hook-form'

import { Input } from '~components/Chat/components'
import { getParseBodyParams, getType } from '~components/Chat/helpers'
import { REQUIRED_VALIDATION } from '~config'

type Props = {
  dialog: Stepper
  dialogType: ApiGetStepResponse['data'][0]['type']
  index: number
  setAnswers: (answer: string) => void
  handleAnswer: Function
}

const Textarea = ({
  dialog,
  dialogType,
  index,
  setAnswers,
  handleAnswer,
}: Props) => {
  const { getValues } = useFormContext()

  const answer = getType(dialog, 'textarea')[0]
  const parsedBodyParam = getParseBodyParams(answer)
  const id = Object.keys(parsedBodyParam)[0]

  const handleTextInputValue = (answer: Answer, id: string) => {
    setAnswers(getValues(id))
    handleAnswer(answer.action, { [id]: getValues(id) })
  }

  return (
    <Input
      key={dialogType + index}
      id={id}
      placeholder={answer.label}
      onSubmit={() => handleTextInputValue(answer, id)}
      validator={REQUIRED_VALIDATION}
    />
  )
}

export default Textarea
